import React from "react";

class IngenSoknaderFunnet extends React.Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="5rem"
                height="5rem"
                viewBox="0 0 73 83"
                aria-hidden="true"
                pointerEvents="none"
                preserveAspectRatio="xMidYMin"
            >
                <title>Skjema med forstørrelsesglass</title>
                <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                    <path
                        fill="#FFF"
                        d="M0 12L13 0h37.996a3 3 0 013 3.004l-.08 64a3 3 0 01-3 2.996H3a3 3 0 01-3-3V12z"
                        transform="translate(-11 -10) translate(11 10)"
                    />
                    <path
                        fill="#C9C9C9"
                        d="M13 0v8.357C13 10.37 11.328 12 9.264 12H0L13 0z"
                        transform="translate(-11 -10) translate(11 10)"
                    />
                    <g fill="#8F9395" transform="translate(-11 -10) translate(11 10) translate(2 10) translate(8 6)">
                        <path d="M0 10L34 10 34 7 0 7z" />
                        <path d="M0 17L34 17 34 14 0 14z" />
                        <path d="M0 24L34 24 34 21 0 21z" />
                        <path d="M0 31L34 31 34 28 0 28z" />
                        <path d="M0 38L34 38 34 35 0 35z" />
                        <path d="M0 3L34 3 34 0 0 0z" />
                    </g>
                    <g fillRule="evenodd" transform="translate(-11 -10)">
                        <path
                            fill="#B1CAC9"
                            d="M59.043 20.884C63.495 27.233 62 36.02 55.702 40.508c-6.3 4.489-15.015 2.98-19.467-3.37-4.453-6.349-2.956-15.136 3.343-19.624 6.298-4.489 15.013-2.98 19.465 3.37z"
                        />
                        <path
                            fill="#C52C35"
                            d="M72.368 63.239a3.129 3.129 0 01-4.384-.76L57.268 47.198a3.186 3.186 0 01.753-4.419 3.128 3.128 0 014.382.76L73.12 58.82a3.187 3.187 0 01-.752 4.419"
                        />
                        <path
                            fill="#2F3238"
                            d="M40.588 17.918c-5.825 4.151-7.213 12.306-3.097 18.178 4.117 5.87 12.207 7.27 18.031 3.12 5.825-4.15 7.214-12.306 3.097-18.177-4.117-5.872-12.206-7.272-18.031-3.121m16.144 23.024c-6.768 4.823-16.167 3.197-20.953-3.627-4.784-6.823-3.17-16.299 3.6-21.123 6.767-4.824 16.166-3.197 20.952 3.626 4.784 6.824 3.17 16.3-3.599 21.124"
                        />
                        <path
                            fill="#2F3238"
                            d="M59.86 45.403c-.944.673-1.966.857-2.635-.097l-2.234-3.187a2.124 2.124 0 01.502-2.945 2.085 2.085 0 012.922.505l2.234 3.187c.668.954.157 1.863-.788 2.537"
                        />
                        <path
                            fill="#D94C56"
                            d="M58.52 47.636L68.634 62.06c.335.477.988.59 1.46.253.474-.337.586-.996.251-1.473l-9.679-13.804c-.802.55-1.558.696-2.146.6"
                        />
                        <path
                            fill="#E7E6E2"
                            d="M81.368 53.066c1.076 0 1.946.766 1.946 1.71V72.97c0 .945-.87 1.71-1.946 1.71-1.074 0-1.945-.765-1.945-1.71V54.776c0-.944.871-1.71 1.945-1.71M77.097 50.117c1.075 0 1.946.876 1.946 1.961v23.589c0 1.084-.871 1.96-1.946 1.96a1.953 1.953 0 01-1.946-1.96V52.078c0-1.085.871-1.96 1.946-1.96M72.825 46.788c1.074 0 1.946.88 1.946 1.962v28.273c0 1.083-.872 1.96-1.946 1.96a1.952 1.952 0 01-1.945-1.96V48.75c0-1.082.87-1.962 1.945-1.962M68.552 43.86c1.075 0 1.946.88 1.946 1.961v18.864c0 1.084-.87 1.962-1.946 1.962a1.953 1.953 0 01-1.946-1.962V45.821c0-1.082.87-1.961 1.946-1.961"
                        />
                        <path
                            fill="#E7E6E2"
                            d="M81.11 78.117v-2.436c0-.667 1.153-1.223 1.153-1.223L79.866 54.89H68.552l-1.946 6.426s-.477.147-.953-.59c-.476-.741-1.905-4.212-1.905-4.212s-1.903-4.096-3.664-3.359c-1.756.738-.951 3.433-.951 3.433s.896 4.25 1.393 6.278c.626 2.563 2.088 5.17 3.296 7.092 1.208 1.918 3.516 4.722 4.323 4.722l.184 3.437H81.11z"
                        />
                        <path
                            fill="#561D5B"
                            d="M66.1150442 92.365L83.4256637 92.365 83.4256637 78.1172549 66.1150442 78.1172549z"
                        />
                        <path
                            fill="#7C7086"
                            d="M66.1150442 83.3872255L83.4256637 83.3872255 83.4256637 78.1172549 66.1150442 78.1172549z"
                        />
                        <path
                            fill="#2F3237"
                            d="M81.62 80.79c0-.612-.492-1.108-1.1-1.108-.605 0-1.097.496-1.097 1.108 0 .612.492 1.108 1.098 1.108.607 0 1.1-.496 1.1-1.108"
                        />
                    </g>
                </g>
            </svg>
        );
    }
}

export default IngenSoknaderFunnet;
